<!-- <div *ngIf="loading.isLoading$ | async" class="fixed inset-0 z-[9998] flex flex-col items-center justify-center
            bg-white text-primary"> -->
<!-- <div *ngIf="loading.isLoading$ | async"
    class="fixed inset-0 z-[9998] flex flex-col items-center justify-center
    text-primary min-h-screen bg-[radial-gradient(circle_at_20%_20%,#93c5fd_0%,transparent_45%),radial-gradient(circle_at_80%_25%,#c4b5fd_0%,transparent_50%),radial-gradient(circle_at_50%_75%,#86efac_0%,transparent_50%)] bg-slate-50"> -->
<div *ngIf="loading.isLoading$ | async"
    class="fixed inset-0 z-[9998] flex flex-col items-center justify-center
            text-primary bg-[radial-gradient(circle_at_20%_20%,#bfdbfe_0%,transparent_50%),radial-gradient(circle_at_80%_25%,#ede9fe_0%,transparent_55%),radial-gradient(circle_at_50%_75%,#dcfce7_0%,transparent_55%),radial-gradient(circle_at_25%_80%,#cffafe_0%,transparent_50%)] bg-slate-50">
    <lottie-player src="/assets/loading.json" background="transparent" speed="1"
        [style.width]="(loading.isDefault$ | async) ? '150px' : '130px'"
        [style.height]="(loading.isDefault$ | async) ? '150px' : '130px'" loop autoplay>
    </lottie-player>

    <ng-container *ngIf="loading.isDefault$ | async; else minimalText">
        <div class="flex items-center gap-1 mt-2 loading-dots">
            <span class="text-base font-medium tracking-wide font-heading">
                {{ loading.title$ | async }}
            </span>
            <span class="dot">.</span>
            <span class="dot">.</span>
            <span class="dot">.</span>
        </div>
    </ng-container>

    <ng-template #minimalText>
        <p class="mt-2 text-sm font-medium">
            {{ loading.title$ | async }}
        </p>

        <p *ngIf="loading.subtitle$ | async as subtitle" class="mt-0.5 text-[11px] text-primary/60">
            {{ subtitle }}
        </p>
    </ng-template>

</div>